import moment from 'moment';
import { I18n } from '@aws-amplify/core';

export function formatDate(date: Date): string {
	const result = moment(date).format('L');

	return result;
}

export function showTotal(total: number, range: [number, number]): string {
	const [first, last] = range;
	const result = `${I18n.get('Displaying')} ${first}-${last} ${I18n.get('of')} ${total}`;

	return result;
}
